/** Matches the first column from `createDefaultProjectBoardColumns` in ProjectBoardTab. */
export const PROJECT_BOARD_FIRST_COLUMN_ID = 'col-todo';
